import EmployeeSideBar from "./EmployeeSideBar";
//
const index = () => {
  return (
    <>
      <EmployeeSideBar />
    </>
  );
};

export default index;
